import { createContext, useContext, useMemo, useState } from "react";

import Service from "../../api/service";

const DashboardLevelContext = createContext(null);

export const useDashboardLevelContext = () => {
  const v = useContext(DashboardLevelContext);
  if (!v) {
    throw new Error(
      "useDashboardLevelContext must be used inside DashboardLevelProvider",
    );
  }
  return v;
};

const LEVEL_PATH = {
  First: "first",
  Second: "second",
  Third: "third",
  Fourth: "fourth",
};

export const DashboardLevelProvider = ({ children }) => {
  const [statsLevel, setStatsLevel] = useState(null);

  const fetchLevelData = async (level_id, level) => {
    const segment = LEVEL_PATH[level];
    if (!segment) return null;
    const response = await Service.get(
      `/api/v1/stats/${segment}/level/${level_id}`,
    );
    if (response?.data !== undefined) setStatsLevel(response.data);
    return response;
  };

  const value = useMemo(
    () => ({ statsLevel, fetchLevelData }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [statsLevel],
  );

  return (
    <DashboardLevelContext.Provider value={value}>
      {children}
    </DashboardLevelContext.Provider>
  );
};
